import { Component, OnInit, EventEmitter, Output, OnDestroy } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sales-order-selector',
  templateUrl: './sales-order-selector.component.html',
  styleUrls: ['./sales-order-selector.component.scss']
})
export class SalesOrderSelectorComponent implements OnInit, OnDestroy {

  @Output() selected: EventEmitter<any> = new EventEmitter();

  // states
  loading: boolean = false;
  init: boolean = true;

  // data
  selectedSalesOrder: any;
  salesOrders: any[];

  // endpoints
  private _salesOrderEp = `${this._apiSvc.endpoints.sales}/api/SoHead`;

  // subscriptions
  private _salesOrderSub: Subscription;

  // form group
  form: UntypedFormGroup = this._fb.group({
    SoHeadCode: [null],
    CustomerName: [null]
  });

  constructor(
    private _apiSvc: ApiService,
    private _fb: UntypedFormBuilder
  ) { }

  ngOnInit() {

    this.form.valueChanges
      .pipe(debounceTime(500))
      .subscribe(() => {
        this.init = false;
        this._search();
      });

  }

  ngOnDestroy() {

    if (this._salesOrderSub) {
      this._salesOrderSub.unsubscribe();
    }

  }

  /**
   * Search for sales order by customer or sales order head code
   */
  private _search(): void {

    if (this._salesOrderSub) {
      this._salesOrderSub.unsubscribe();
    }

    const customerName = this.form.get('CustomerName').value,
      soHeadCode = this.form.get('SoHeadCode').value;

    // if there is no search criteria
    if (!customerName && !soHeadCode) {
      this.salesOrders = null;
      this.init = true;
      return;
    }

    this.loading = true;

    let Filter = '';
    if (soHeadCode) {    
      Filter += `SoHeadCode~startswith~'${soHeadCode.trim()}'`;
    }

    if (soHeadCode && customerName) {
      Filter += `~and~`;
    }

    if (customerName && customerName !== '') {
      Filter += `(CustomerFirstName~startswith~'${customerName.trim()}'~or~CustomerLastName~startswith~'${customerName.trim()}'~or~CustomerBothNames~startswith~'${customerName.trim()}')`;
    }

    const params = {
      Filter
    };

    this._salesOrderSub = this._apiSvc.search(this._salesOrderEp, params)
      .subscribe((res: any) => {
        this.salesOrders = res.Data;
        this.loading = false;
      });

  }

  /**
   * Sales order select button event handler
   * @param salesOrder
   */
  onSalesOrderSelection(salesOrder: any): void {
    this.selected.emit(salesOrder);
  }

}
